import { Plugin, View } from "ckeditor5";

export class UiOverrides extends Plugin {
  init() {
    const config = this.editor.config.get("uiOverrides");
    if (config == null) return;

    const componentFactory = this.editor.ui.componentFactory;
    const originalCreate = componentFactory.create.bind(componentFactory);
    componentFactory.create = (name: string) => {
      const view = originalCreate(name);

      if (!(name in config)) return view;

      const override = config[name];

      if (override instanceof Function) {
        override(view);
      } else {
        view.set(override);
      }

      return view;
    };
  }
}

declare module "ckeditor5" {
  interface EditorConfig {
    uiOverrides?: Record<
      string,
      Record<string, any> | ((view: View<HTMLElement>) => void)
    >;
  }
}
